import { Box, Button, Grid, TextField, Typography } from "@mui/material";
import React, { useState } from "react";
import { HeavyCard } from "../components/heavy-card";
import { DEMO_MODE } from "../const/config";
import { Redirect } from "../components/redirect";
import { DEMOS, IDemo } from "../const/demo";
import { Link } from "react-router-dom";

export const DemoLandingPage = () => {
  return (
    <Grid container spacing={5}>
      <Grid item xs={12}>
        <Typography variant="h1">Electify Demo</Typography>
        <Typography variant="h3">To begin, choose one of the demos from the list below.</Typography>
      </Grid>
      <Grid item xs={12}>
        {
          Object.keys(DEMOS).map(d => (
            <Box mt={2}>
              <DemoCard
                key={d}
                demoKey={d}
                demo={DEMOS[d]}
              />
            </Box>
          ))
        }
      </Grid>
    </Grid>
  );
};

interface DemoCardProps {
  demoKey: string;
  demo: IDemo
}
const DemoCard = ({ demoKey, demo }: DemoCardProps) => {
  return (
    <HeavyCard>
      <Grid container>
        <Grid item xs={12} >
          <Typography variant="h4">{demo.label}</Typography>
          <Typography variant="subtitle1">{demo.description}</Typography>
        </Grid>

        <Grid item xs={12} mt={2} >
          {demo.diagram}
        </Grid>
        <Grid item xs={12} >
          <Box sx={{ display: "flex", justifyContent: "end" }}>
            <Link to={`/voting/${demoKey}`}>
              <Button size="large" variant="contained">
                Try it out!
              </Button>
            </Link>
          </Box>
        </Grid>
      </Grid>
    </HeavyCard>
  )
}